exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-e3abf1c0]{height:34px!important;border-radius:3px!important;padding:1px 8px}.small-description[data-v-e3abf1c0]{line-height:11px}", ""]);

// exports
